export default __webpack_public_path__ + "static/media/health.8ed1aaff.svg";